import { Service } from './Service.interface';
import { SubService } from '@models/SubService/SubService.interface';
import { SubServiceModel } from '@models/SubService/SubService.model';
import { Mark } from '@models/Mark/Mark.interface';
import { MarkModel } from '@models/Mark/Mark.model';

export class ServiceModel implements Service {
  id: number;
  parentId?: number;
  title: string;
  marks: Mark[];
  isElectronic: boolean;
  url?: string | null;
  isPopularGlobal: boolean;
  subServices?: SubService[];
  routePath: string;
  openedRoutePath: string;

  constructor(data: any) {
    this.id = data.id ? data.id : null;
    this.parentId = data.parentId ? data.parentId : null;
    this.title = data.entity && data.entity.title ? data.entity.title : '';
    this.marks = [];
    if (data.entity && data.entity.marks) {
      data.entity.marks.forEach((mark: any) =>
        this.marks.push(new MarkModel(mark))
      );
    }
    this.isPopularGlobal = data.isPopularGlobal ? data.isPopularGlobal : false;
    this.subServices = [];
    if (data.entity && data.entity.subServices) {
      data.entity.subServices.forEach((subService: any) =>
        this.subServices!.push(
          new SubServiceModel({
            ...subService,
            isPopularGlobal: this.isPopularGlobal,
          })
        )
      );
    }
    this.isElectronic =
      data.entity && data.entity.isElectronic
        ? data.entity.isElectronic
        : false;
    if (this.isPopularGlobal) {
      this.url =
        data.entity && data.entity.formLink ? data.entity.formLink : '';
    } else {
      this.url =
        data.entity && data.entity.fullViewLink ? data.entity.fullViewLink : '';
    }
    this.routePath = data.routePath ? data.routePath : false;
    this.openedRoutePath = data.openedRoutePath ? data.openedRoutePath : false;
  }
}
